import React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

interface IFormInput {
    id?: string;
    name: string;
    label: string;
    control?: any;
    error?: any;
    maxLength?: number;
    disabled?: boolean;
}

// Remove qualquer caractere de formatação (pontos, barras, hífens, espaços),
// mantendo apenas letras e dígitos, para enviar o documento limpo ao backend.
// Ex.: "CU.R73.JA1/0001-56" -> "CUR73JA1000156"
const sanitizeDocumento = (value: string) => value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

const inputDocumento: React.FC<IFormInput> = ({ id, name, label, control, error, maxLength, disabled }) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange: renderChange, value, onBlur } }) => (
                <TextField
                    id={id}
                    value={value || ""}
                    onBlur={onBlur}
                    margin="normal"
                    size="small"
                    label={label}
                    variant="outlined"
                    error={!!error && !!error[name]}
                    helperText={!!error && error[name]?.message}
                    fullWidth
                    disabled={disabled}
                    onChange={(event) => renderChange(sanitizeDocumento(event.target.value))}
                    inputProps={{
                        maxLength: maxLength,
                    }}
                />
            )}
        />
    );
};

export default inputDocumento;
